import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Pagination,
  CircularProgress,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import { filterArticles } from "../../models/Article";
import ArticleCardList from "../Layout/ArticleCardList";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import { useLocation } from "react-router-dom";

const HISTORY_CATEGORY_ID = 2;

const periods = [
  { label: "Kháng chiến chống Pháp", value: "KCCP" },
  { label: "Kháng chiến chống Mỹ", value: "KCCM" },
  { label: "1975 - nay", value: "1975" },
];

export default function HistorySection() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const defaultTimeline = params.get("timeline") || "";

  const [timeline, setTimeline] = useState(defaultTimeline);
  const [sortType, setSortType] = useState("desc");
  const [page, setPage] = useState(1);
  const [itemsPerPage] = useState(6);
  const [articles, setArticles] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const getTimelineId = (timelineValue) => {
    switch (timelineValue) {
      case "KCCP":
        return 1;
      case "KCCM":
        return 2;
      case "1975":
        return 3;
      default:
        return undefined;
    }
  };

  const fetchArticles = async () => {
    setLoading(true);
    const timeline_id = getTimelineId(timeline);

    try {
      const res = await filterArticles({
        page,
        limit: itemsPerPage,
        category_id: HISTORY_CATEGORY_ID,
        timeline_id,
        sort: sortType,
      });

      if (res) {
        setArticles(res.data);
        setTotalPages(Math.ceil(res.total / itemsPerPage));
      } else {
        setArticles([]);
      }
    } catch (err) {
      throw err;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArticles();
  }, [page, sortType, timeline]);


  return (
    <Box sx={{ px: 2, py: 5, maxWidth: 1440, mx: "auto" }}>
      <Paper
        elevation={2}
        sx={{
          maxWidth: 900,
          mx: "auto",
          mb: 5,
          px: 4,
          py: 3,
          borderRadius: 2,
          backgroundColor: "#faf7f1",
        }}
      >
        <Box display="flex" justifyContent="center" mb={1}>
          <FormatQuoteIcon sx={{ fontSize: 40, opacity: 0.3 }} />
        </Box>
        <Typography
          variant="h6"
          align="center"
          fontStyle="italic"
          sx={{ lineHeight: 1.6 }}
        >
          <Box component="span" fontWeight="bold" fontStyle="normal">
            Lược sử
          </Box>{" "}
          là hành trình tóm lược những dấu ấn quan trọng trong dòng chảy lịch sử dân
          tộc. Đây là hành trang giúp chúng ta nhìn lại quá khứ để hiểu rõ hơn về hiện tại và
          trân trọng những giá trị đã hun đúc nên bản sắc Việt.
        </Typography>
      </Paper>
      <Box sx={{ width: "100%", height: 1, backgroundColor: "#e0e0e0", mb: 4 }} />
      <Grid container spacing={4} justifyContent={{ xs: "center", md: "flex-start" }}>
        {/* Bộ lọc bên trái */}
        <Grid item xs={12} md={3}>
          <Paper elevation={3} sx={{ p: 2, position: "sticky", top: 100, borderRadius: 2 }}>
            <Typography variant="h6" fontWeight={700} mb={2}>
              Giai đoạn
            </Typography>
            <List>
              <ListItem disablePadding>
                <ListItemButton selected={timeline === ""} onClick={() => setTimeline("")}>
                  <ListItemText primary="Tất cả" />
                </ListItemButton>
              </ListItem>
              {periods.map((p) => (
                <ListItem disablePadding key={p.value}>
                  <ListItemButton
                    selected={timeline === p.value}
                    onClick={() => {
                      setTimeline(p.value);
                      setPage(1);
                    }}
                  >
                    <ListItemText primary={p.label} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>

            <Typography variant="h6" fontWeight={700} mt={4} mb={2}>
              Lọc theo thời gian
            </Typography>
            <List>
              <ListItem disablePadding>
                <ListItemButton
                  selected={sortType === "desc"}
                  onClick={() => {
                    setSortType("desc");
                    setPage(1);
                  }}
                >
                  <ListItemText primary="Mới nhất → Cũ nhất" />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton
                  selected={sortType === "asc"}
                  onClick={() => {
                    setSortType("asc");
                    setPage(1);
                  }}
                >
                  <ListItemText primary="Cũ nhất → Mới nhất" />
                </ListItemButton>
              </ListItem>
            </List>
          </Paper>
        </Grid>

        {/* Nội dung bài viết */}
        <Grid item xs={12} md={9} >

          {loading ? (
            <Box display="flex" justifyContent="center" py={6}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <ArticleCardList articles={articles} />
              <Box display="flex" justifyContent="center" mt={4}>
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={(_, value) => setPage(value)}
                  color="primary"
                />
              </Box>
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

